// extracted by mini-css-extract-plugin
module.exports = {"loading":"myresume_loading__klpED","my-resume-unverified-profile":"myresume_my-resume-unverified-profile__bkVIw"};